import initProductsFaq from "components/jiffy/products-faq/products-faq";

document.addEventListener("DOMContentLoaded", () => {
  initProductsFaq();
});
